import React from 'react';
import ReactTooltip from 'react-tooltip';
import { selectableSpinDirectionOptions } from 'js/config/animationOptions';
import { useActiveScene } from 'js/shared/hooks/useActiveScene';

import OptionMenuButton, { OptionMenuButtonIconAndText } from './OptionMenuButton';
import { useAnimationStageContext } from './AnimationStageContext';

import './SpinDirectionMenu.css';

const TOOLTIP_ID = 'spin-direction-tooltip';

const SpinDirectionMenu = () => {
  const { currentSelectedSpinValue, onSpinDirectionChoice } = useAnimationStageContext();
  const activeScene = useActiveScene();

  if (!activeScene) {
    return null;
  }

  const currentSelectedValue = currentSelectedSpinValue;

  return (
    <div className="SpinDirectionMenu">
      <div className="SpinDirectionMenu__Grid">
        {selectableSpinDirectionOptions.map(dir => {
          if (dir.label === 'Scene Thumbnail') {
            return (
              <div key={dir.label} className="SpinDirectionMenu__SceneContainer">
                <img className="SpinDirectionMenu__SceneTile" src={activeScene.thumbnailImage} alt={dir.label} />
              </div>
            );
          }
          return (
            <OptionMenuButton
              key={dir.label}
              selected={dir.value === currentSelectedValue}
              onClick={() => onSpinDirectionChoice(dir.value)}
              tooltipProps={{
                'data-tip': dir.label,
                'data-for': TOOLTIP_ID
              }}
            >
              <OptionMenuButtonIconAndText icon={dir.Icon()}>{dir.label}</OptionMenuButtonIconAndText>
            </OptionMenuButton>
          );
        })}
      </div>
      <ReactTooltip id={TOOLTIP_ID} className="t-utility-label" />
    </div>
  );
};

export default SpinDirectionMenu;
